export default "__VITE_ASSET__DXwO9J3f__"